import { Component, OnInit, OnDestroy, Output, EventEmitter, HostListener } from '@angular/core';

import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { CommonUtil } from '../../core/Utils/common-util';

import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.css']
})
export class ProfileMenuComponent implements OnInit, OnDestroy {

  rootScopeData: RootScopeDeclare;
  isRtl: boolean;
  currentFacility: FacilityObject;
  profileDropdownVisibility: boolean = false;
  private sub = new Subscription();
  // subscriptions

  @Output() onsignout: EventEmitter<string> = new EventEmitter();

  constructor(private rootScopeService: RootScopeService, public commonUtil: CommonUtil, private _router: Router,
    private _facilityService: FacilityService) {

  }

 /* @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      $event.returnValue = this.commonUtil.translateText('UNSAVED.CHANGES.MESSAGE');
    }
  }*/

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    this.getRootScopeData();
    this.changeToRtl();
     // subscript facility change / when facility change
     this.currentFacility = this._facilityService.selectedFacility();
     const _facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
       this.currentFacility = res;
     });
     this.sub.add(_facilityOnChange);
  }

  
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  changeToRtl(): void {
    const selectedLang = this.rootScopeData.selectedLang;
    this.isRtl = false;
    if (selectedLang === 'ar' || selectedLang === 'he') {
      this.isRtl = true;
    }
  }

  tryToMoveAwayFromCurrentPage(path: string): void {
    this.profileDropdownVisibility = false;
    this.rootScopeData.pathToNavigate = path;
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      return;
    } else {
      this._router.navigate([path]);
    }
  }

  trySignOut() {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.tryToMoveAwayFromCurrentPage('signout');
    } else {
      this.onsignout.emit();
    }
  }

}
